import * as React from "react";
import type { SVGProps } from "react";
const SvgSkier = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#skier_svg__a)">
      <path d="M17.68 7.39a2.5 2.5 0 0 1-.75-.12 2.34 2.34 0 0 1-1.37-1.19 2.37 2.37 0 0 1-.13-1.81l.22-.65a2.34 2.34 0 0 1 1.19-1.37 2.37 2.37 0 0 1 1.81-.13 2.38 2.38 0 0 1 1.5 3l-.22.65a2.34 2.34 0 0 1-1.19 1.37 2.3 2.3 0 0 1-1.06.25M17.9 4a.4.4 0 0 0-.17 0 .4.4 0 0 0-.18.21l-.22.66a.36.36 0 0 0 0 .28.44.44 0 0 0 .21.19.37.37 0 0 0 .29 0 .32.32 0 0 0 .18-.21l.22-.65A.37.37 0 0 0 18 4a.3.3 0 0 0-.1 0M11 12a1 1 0 0 1-.8-1.6l3-4a1 1 0 1 1 1.6 1.2l-3 4a1 1 0 0 1-.8.4" />
      <path d="M20 13q-.12.015-.24 0l-.43-.11a9 9 0 0 1-5.87-4.7l-.35-.71a1 1 0 0 1 .44-1.34 1 1 0 0 1 1.34.44l.36.71a7 7 0 0 0 4.56 3.66l.43.11a1 1 0 0 1 .73 1.21A1 1 0 0 1 20 13M21 22h-2a20.9 20.9 0 0 1-6.18-.93L2.71 18a1 1 0 0 1-.487-1.596 1 1 0 0 1 1.067-.324l10.13 3.12c1.81.544 3.69.814 5.58.8h2a1 1 0 1 1 0 2M14 16a1 1 0 0 1-.8-.4l-3-4a1 1 0 0 1 1.6-1.2l3 4A1 1 0 0 1 14 16" />
      <path d="M12 20a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l2-4a1 1 0 0 1 1.34-.44 1 1 0 0 1 .44 1.34l-2 4A1 1 0 0 1 12 20M20 13H3a1 1 0 0 1 0-2h17a1 1 0 0 1 0 2" />
    </g>
    <defs>
      <clipPath id="skier_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSkier;
